module.exports = __webpack_public_path__ + "static/media/icon-no-notif.946c8a1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-no-notif.svg
// module id = 555
// module chunks = 0